/* eslint-disable jira/filename-case */
import type {
	ComponentType,
	ForwardRefExoticComponent,
	PropsWithoutRef,
	RefAttributes,
} from 'react';
import withAnalyticsContext, {
	type WithContextProps,
} from '@atlaskit/analytics-next/withAnalyticsContext';
import type { ScreenType } from '../utils/types.tsx';

export type ContextResult<C, P> = ForwardRefExoticComponent<
	PropsWithoutRef<JSX.LibraryManagedAttributes<C, P & WithContextProps>> & RefAttributes<C>
>;

export const AnalyticsSource =
	(name: string, type: ScreenType) =>
	<C extends ComponentType<P>, P = React.ComponentProps<C>>(
		WrappedComponent: C,
	): ContextResult<C, P> =>
		withAnalyticsContext({ source: `${name}${type}` })<P, C>(WrappedComponent);

export const AnalyticsSubject =
	(
		name: string,
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		attributes?: Record<any, any>,
	) =>
	<C extends ComponentType<P>, P = React.ComponentProps<C>>(
		WrappedComponent: C,
	): ContextResult<C, P> =>
		withAnalyticsContext({
			actionSubject: name,
			attributes,
		})<P, C>(WrappedComponent);
